import ApiWorkspacesRepository from "../Repositories/WorkSpaces/ApiWorkspacesRepository";
import type {
  BaseWorkspacesRepository,
  WorkspaceResource,
  WorkspacesList,
  UpdateWorkspaceData,
} from "../Repositories/WorkSpaces/BaseWorkspacesRepository.interface";
import ExperimentalWorkspacesRepository from "../Repositories/WorkSpaces/ExperimentalWorkspacesRepository";

type WorkspacesServiceType = "api" | "experimental";

class WorkspacesService {
  private type: WorkspacesServiceType = "api";
  private Repository!: BaseWorkspacesRepository;

  constructor(type: WorkspacesServiceType) {
    this.type = type;
    this.assignRepository();
  }

  private assignRepository() {
    switch (this.type) {
      case "api":
        this.Repository = new ApiWorkspacesRepository();
        break;
      case "experimental":
        this.Repository = new ExperimentalWorkspacesRepository();
        break;
      default:
        this.Repository = new ApiWorkspacesRepository();
    }
  }

  async getAll(): Promise<WorkspacesList | null> {
    return await this.Repository.getAll();
  }

  async create(workspace: Omit<WorkspaceResource, "current">): Promise<WorkspaceResource | null> {
    return await this.Repository.create(workspace);
  }

  async getCurrent(): Promise<string | null> {
    return await this.Repository.getCurrent();
  }

  async use(path: string): Promise<boolean> {
    return await this.Repository.use(path);
  }

  async delete(workspaceId: string): Promise<{ error: boolean; message: string }> {
    return await this.Repository.delete(workspaceId);
  }

  async update(
    workspaceId: string,
    data: UpdateWorkspaceData
  ): Promise<{ error: boolean; message: string; data?: WorkspaceResource }> {
    return await this.Repository.update(workspaceId, data);
  }
}

export default WorkspacesService;
